import { createFileRoute } from '@tanstack/react-router'

import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { elementTypesListFilters } from '@/components/Internal/HouseElementTypes/element-types-list-filters'
import { ElementTypesView } from '@/components/Internal/HouseElementTypes/ElementTypesView'

export const Route = createFileRoute(
  '/internal/system/administration/element-types',
)({
  validateSearch: listSearchValidator(elementTypesListFilters),
  component: ElementTypesScreen,
})

function ElementTypesScreen() {
  const filters = useListFilters(elementTypesListFilters, Route)

  return <ElementTypesView filters={filters} />
}
